import styled from "styled-components";

export const Container = styled.div`
  max-height: calc(100vh - 57px);
  overflow: auto;
  @media (max-width: 850px) {
    max-height: calc(100vh - 129px);
  }
`;

export const Header = styled.div`
  padding: 0 20px 21px;
  display: flex;
  align-items: flex-start;
  /* background: #f2f6fa; */
  gap: 15px;
  justify-content: space-between;
  box-shadow: 0px 15px 8px -15px #111;
  .active {
    background: var(--theme-background);
    color: #fff;
  }
`;
export const FormWraper = styled.div`
  display: flex;
  -ms-flex-pack: end;
  justify-content: flex-end;
  /* padding-top: 12px; */
  padding-right: 21px;
`;
export const BodyWrapper = styled.div`
  padding: 22px 21px;
  display: flex;
  gap: clamp(20px, 3.75vw, 72px);
  /* max-height: calc(100vh - 275px); */
  overflow: auto;
  > div {
    flex: 1;
    box-shadow: 0px 4px 5px rgba(0, 0, 0, 0.05);
    .circle-btn {
      border: none;
      padding: 0 0 0 40px;
    }
  }
  @media (max-width: 890px) {
    flex-direction: column;
    > div {
    .circle-btn {
      padding: 0 0 0 17px;
    }
  }}
  @media (max-width: 550px) {
    > div {
    .circle-btn {
      display: grid;
    grid-template-columns: 15px auto;
    text-align: left;

    }
  }}
`;

export const Heading = styled.div`
  font-size: 16px;
  line-height: 150.5%;
  padding: 13px 28px;
  background: var(--box-header-background);
  color: var(--text-primary);
  margin-bottom: 26px;
  font-family: "latobold";
  border: var(--box-header-border);
  @media (max-width: 890px) {
    margin-bottom: 15px;
  }
`;
export const HeaderBtn = styled.button`
  height: 30px;
  border: 1px solid #cdcfd0;
  border-radius: 6px;
  font-size: 13px;
  line-height: 150.5%;
  color: #1d1d1d;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  background-color: transparent;
`;

export const BoxWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 20px 29px;
  padding: 0 30px 15px;
  display: grid;
  grid-template-columns: 1fr 1fr;
  margin-top: 24px;
  max-height: calc(100vh - 462px);
  overflow: auto;

  @media (max-width: 1276px) {
    grid-template-columns: 1fr;
  }
  @media (max-width: 890px) {
    max-height: calc(100vh - 503px);
  }
  @media (max-width: 850px) {
    padding: 0 15px 15px;
    margin-top: 15px;
  }
`;

export const DataBox = styled.div`
  height: 89px;
  background: #ffffff;
  border: 1px solid #e7e7e7;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.05);
  border-radius: 10px;
  display: flex;
  align-items: center;
  padding: 21px 27px 15px 19px;
  gap: 23px;
  .delete-icon-btn {
    border: none;
    background: transparent;
    padding: 0;
  }
  svg {
    pointer-events: none;
  }
  > div {
    flex: 1;
    p {
      font-size: 16px;
      :last-child {
        font-size: 20px;
        font-family: "latobold";
        margin-top: 3px;
      }
      span {
        color: #00945f;
      }
    }
  }
  @media (max-width: 850px) {
    padding: 8px 13px;

    > div {
      p {
        font-size: 14px;
        :last-child {
          font-size: 14px;
        }
      }
    }
  }
`;

export const ActionBtn = styled.div`
   display: flex;
  align-items: center;
  gap: 20px;
  margin: 28px 0 15px;
  padding: 0 20px;

  button {
    display: flex;
    font-size: 13px;
    line-height: 150.5%;
    color: #1d1d1d;
    padding: 5px 15px;
    border: 1px solid #636f7c;
    border-radius: 30px;
    align-items: center;
    gap: 5px;
    background-color: #fff;
    font-family: "latoregular";
    white-space: nowrap;
    text-transform: capitalize;
    &.disabled {
      color:rgba(0, 0, 0, 0.26);
      pointer-events: none;
      .icon {
        opacity: 0.5;
      }
    }
    &.active {
      background: rgb(188,155,106);
    color: rgb(255,255,255);
    border-color: transparent;
    }
  }
`;
export const PopContainer = styled.div`
  padding: 0;
  .modal-body {
    padding: 10px 29px;
    .input-wrapper {
      margin-bottom: 18px;
      p {
        font-size: 13px;
        line-height: 150.5%;
        color: #000;
        margin-bottom: 10px;
      }
      input {
        background: #ffffff;
        border: 1px solid #cdcfd0;
        border-radius: 6px;
        max-width: 344px;
        width: 100%;
        height: 26px;
        margin-bottom: 14px;
        padding: 0 8px;
      }
      .des {
        color: #636f7c;
        font-size: 12px;
      }
    }
  }
  
`;
export const ModalHeader = styled.h3`
  font-size: 14px;
  line-height: 150.5%;
  padding: 10px 28px;
  background: var(--filter-bar-bg);
  border-radius: 5px 5px 0px 0px;
  color: var(--theme-text);
`;
